
import { defineComponent } from 'vue';
import Sources from '../components/Sources.vue';
import References from '../components/References.vue';
import Definitions from '../components/Definitions.vue';
import Contexte from '../components/Contexte.vue';
import Remerciements from '../components/Remerciements.vue';
import Suggestions from '../components/Suggestions.vue';
import PNGViewer from '../components/PNGViewer.vue';
import PNGViewerOrange from '../components/PNGViewerOrange.vue';
import RecoHas from '../components/RecoHas.vue';
import Reco from '../components/Reco.vue';
import RecoHasSup65 from '../components/RecoHasSup65.vue';
import RecoInca from '../components/RecoInca.vue';
import VoirSources from '../components/VoirSources.vue';

type Nav = {
  navId: string;
  keyword: string;
  color: string;
}

export default defineComponent({
  name: 'Home',
  components: {
    Sources,
    References,
    Definitions,
    Contexte,
    Remerciements,
    Suggestions,
    PNGViewer,
    PNGViewerOrange,
    RecoHas,
    Reco,
    RecoHasSup65,
    RecoInca,
    VoirSources,
  },
  data() {
    return {
      navigation: [] as Array<Nav>,
      nav: '',
      age: '',
      color: '',
      endNav: '',
      item: '',
      end: false,
    };
  },
  methods: {
    goDirectlyTo(data: any) {
      this.age = data.age;
      this.color = data.ageColor;
      const currentNavigation = {
        color: data.color,
        navId: data.navId,
        keyword: data.keyword,
      };
      this.nav = data.navId;
      this.navigation = [currentNavigation];
      console.log(this.nav);
      console.log(this.navigation);
    },
    showNav(nav: Nav) {
      this.navigation = this.navigation.slice(0, this.navigation.indexOf(nav) + 1);
      this.nav = nav.navId;
      this.endNav = '';
    },
    goHome() {
      this.navigation = [];
      this.nav = '';
      this.endNav = '';
      this.item = '';
    },
    resetOther(toReset: string[]) {
      toReset.forEach((idButton: string) => {
        const currentSection = document.getElementById(idButton) as HTMLElement;
        currentSection.classList.remove('clicked');
      });
    },
    toggleClicked(nav: string) {
      const currentSection = document.getElementById(nav) as HTMLElement;
      currentSection.classList.toggle('clicked');
      if (!currentSection.classList.contains('clicked')) {
        this.endNav = '';
      }
    },
    showEnd(question: string, answer: string) {
      this.endNav = `${this.nav}${question}:${answer};`;
    },
    toggleContent(nav: string) {
      const currentSection = document.getElementById(nav) as HTMLElement;
      currentSection.classList.toggle('shown');
    },
    hasAnswered(question: string, answer: string, keyword: string, color: string) {
      const newNav = `${this.nav}${question}:${answer};`;
      this.nav = newNav;
      this.navigation.push(
        {
          navId: newNav,
          keyword,
          color,
        },
      );
      console.log(this.navigation);
      console.log(this.nav);
    },
    hasAnsweredAge(question: string, answer: string, keyword: string, color: string) {
      this.nav = `${question}:${answer};`;
      this.age = keyword;
      this.color = color;
      this.navigation = [];
    },
    goBack() {
      this.endNav = '';
      if (this.item !== '') {
        this.item = '';
      } else if (!this.end) {
        this.navigation.pop();
        const currentNav = this.nav.split(';');
        if (currentNav.length === 2) {
          this.nav = '';
        } else {
          currentNav.reverse().splice(1, 1);
          this.nav = currentNav.reverse()
            .join(';');
        }
        console.log(this.nav);
      }
    },
    isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || window.matchMedia('(max-width: 1024px)').matches;
    },
    toggleItem(item: string) {
      this.item = item;
    },
  },
});
